export const Global_Mutation = {
    REQUEST_ERROR: "REQUEST_ERROR",
    REQUEST_STATE: "REQUEST_STATE",
    CHANGE_STATUS: "CHANGE_STATUS",
    CHANGE_MOBILE: "CHANGE_MOBILE",
    CHANGE_SHOW_SIDE_MENU: "CHANGE_SHOW_SIDE_MENU",
    CHANGE_SHOW_SETTINGS: "CHANGE_SHOW_SETTINGS",
    CHANGE_SHOW_BANNER: "CHANGE_SHOW_BANNER"
};